import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectEvaluationsListItems } from "../../../../../../redux/evaluations/selector";
import { evaluations } from "../../../../../../redux/evaluations/action";

const SrmContainer = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const itemsData = useSelector(selectEvaluationsListItems)
  const [ columnDefs,setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
      setColumnDefs([
        {
          field: 'Sl',
          sortable: false,
          filter: false,
          isSortLabel: true,
          headerName: 'Sl',
          cellRenderer (params: any) {
            return parseInt(
              params.node.id,
              10
            ) + 1;
          },
        },
        { field: 'Name', headerName: 'Name' },
        { field: 'OwnerTypeName', headerName: 'OwnerType Name' },
        { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
      ]);
    }
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    
    navigate(`${data?.Id}`)
  }
  
  const handleDelete=(data: any)=>{
    dispatch(evaluations.delete({
      url: `https://evp.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/service/esa/evaluations/delete`,
      entity: 'evaluations',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
  })).then(() => {
    dispatch(evaluations.list({
      url: `https://evp.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/service/esa/evaluations/list`,
      entity: 'evaluations',
      jsonData: { "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",}
    }));
  });
  }
      
//   const additionButtons: any = [
//     {
//       name: 'Add Evaluations',
//       callback: () => handleAdd(),
//     }
//   ];

  const fetchEvaluations=()=>{

    dispatch(evaluations.list({
      url:`https://evp.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/service/esa/evaluations/list`,
      entity:'evaluations',
      jsonData:{
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc"
    }}))     
  }
	useEffect(() => {
   
    createColumnDefs()
    fetchEvaluations()
	}, [pageData,pageSize])
    

	return (
    <>
    {itemsData?.isLoading ? 
    <PageLoader /> : 
    <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
    paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} headingName="Evaluations" />
    }
    </>
	);
};

export default SrmContainer;


